import React from 'react';
import ButtonGetPacientPhoto from './ButtonGetPacientPhoto'

class GetPatinentPhotos extends React.Component {

    constructor(){
        super();
        this.onHandleChange = this.onHandleChange.bind();
    }

    onHandleChange = (file, name) => {
        this.props.onChangeImageHandler(file, name);
    } 

    render() {
        return (
            <div className="col-md-md-12">
                <div className="vertical-separator-20px"></div> 

                <div className="row justify-content-md-center">
                    <div className="col-md-4 col-md-offset-4">
                        <ButtonGetPacientPhoto 
                            name="frontSerious"
                            onChangeImageHandler={this.onHandleChange}
                            imageTitle="1.-De frente, sin sonrisa"
                        />
                    </div>
                </div>

                <div className="vertical-separator-50px "></div>

                <div className="row justify-content-md-center">   
                    <div className="col-md-4">
                        <ButtonGetPacientPhoto 
                            name="trueSmile"
                            onChangeImageHandler={this.onHandleChange}
                            imageTitle="2.-Frente sonrisa natural"
                        />
                    </div>

                    <div className="col-md-4">
                        <ButtonGetPacientPhoto 
                            name="profileLeft"
                            onChangeImageHandler={this.onHandleChange}
                            imageTitle="3.-De perfil lado izquierdo"
                        />
                    </div>

                    <div className="col-md-4">
                        <ButtonGetPacientPhoto 
                            name="profileRight"
                            onChangeImageHandler={this.onHandleChange}
                            imageTitle="4.-De perfil lado derecho"
                        />
                    </div>
                </div>

                <div className="vertical-separator-50px "></div>


                <div className="row justify-content-center">   
                    <div className="col-md-4">
                        <ButtonGetPacientPhoto 
                            name="frontOcclusion"
                            onChangeImageHandler={this.onHandleChange}
                            imageTitle="5.-De frente en oclusión"
                        />
                    </div>

                    <div className="col-md-4">
                        <ButtonGetPacientPhoto 
                            name="rightLateralOcclusion"
                            onChangeImageHandler={this.onHandleChange}
                            imageTitle="6.-Lateral oclusión derecha"
                        />
                    </div>


                    <div className="col-md-4">
                        <ButtonGetPacientPhoto 
                            name="leftLateralOcclusion"
                            onChangeImageHandler={this.onHandleChange}
                            imageTitle="7.-Lateral oclusión izquierda"
                        />
                    </div>


                </div>

                <div className="vertical-separator-50px "></div>

                <div className="row justify-content-center">
                    
                    <div className="col-md-4">
                        <ButtonGetPacientPhoto 
                            name="superiorOcclusion"
                            onChangeImageHandler={this.onHandleChange}
                            imageTitle="8.-Oclusal superior"
                        />
                    </div>

                    <div className="col-md-4">
                        <ButtonGetPacientPhoto 
                            name="lowerOcclusion"
                            onChangeImageHandler={this.onHandleChange}
                            imageTitle="9.-Oclusal inferior"

                        />
                    </div>


                    <div className="col-md-4">
                        <ButtonGetPacientPhoto 
                            name="overbite"
                            onChangeImageHandler={this.onHandleChange}
                            imageTitle="10.-Sobremordida"
                        />
                    </div>

                </div>


            </div>
        );
    }
}



export default GetPatinentPhotos;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/QuestionsTypes/GetPatinentPhotos.js